import { useState } from 'react'
import { notify } from '../utilities/util'

const ALLOWED_TYPES = ['image/png', 'image/jpg', 'image/jpeg']

const useImageUpload = () => {
  const [file, setFile] = useState<File | null>(null)
  const [profileImg, setProfileImg] = useState<string>('')
  const [profileImgError, setProfileImgError] = useState(false)
  const [loadingImage, setLoadingImage] = useState(false)

  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0]
    if (!selectedFile) return

    if (!ALLOWED_TYPES.includes(selectedFile.type)) {
      notify('Please select file type png, jpg or jpeg.', 'error')
      return
    }

    setLoadingImage(true)
    setFile(selectedFile)
    const reader = new FileReader()
    reader.onload = () => {
      setProfileImg(reader.result as string)
      setProfileImgError(false)
      setLoadingImage(false)
    }
    reader.onerror = () => {
      setLoadingImage(false)
      notify('Failed to read image file.', 'error')
    }
    reader.readAsDataURL(selectedFile)
  }

  const resetImage = () => {
    setFile(null)
    setProfileImg('')
    setProfileImgError(false)
  }

  return {
    file,
    profileImg,
    setProfileImg,
    profileImgError,
    setProfileImgError,
    loadingImage,
    handleFile,
    resetImage,
  }
}

export default useImageUpload
